import { render, staticRenderFns } from "./DeleteReasonsModal.vue?vue&type=template&id=4a4fe769&"
import script from "./DeleteReasonsModal.vue?vue&type=script&lang=js&"
export * from "./DeleteReasonsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports